import {
  SET_CART_ID,
  AUTO_APPLY_COUPON,
  RESET_AUTO_APPLY_COUPON,
} from "../actions/types"
import {
  SetCartIdAction,
  AutoApplyCouponAction,
  ResetAutoApplyCouponAction,
} from "../actions/cartActions"

const INITIAL_STATE: {
  cartId: string | undefined
  attemptedAutoApplyCoupons: { [code: string]: boolean }
} = {
  cartId: undefined,
  attemptedAutoApplyCoupons: {},
}

type Actions =
  | SetCartIdAction
  | AutoApplyCouponAction
  | ResetAutoApplyCouponAction

export default (state = INITIAL_STATE, action: Actions) => {
  switch (action.type) {
    case SET_CART_ID:
      return { ...state, cartId: action.payload }
    case AUTO_APPLY_COUPON:
      return {
        ...state,
        attemptedAutoApplyCoupons: {
          ...state.attemptedAutoApplyCoupons,
          [action.payload]: true,
        },
      }
    case RESET_AUTO_APPLY_COUPON:
      return {
        ...state,
        attemptedAutoApplyCoupons: {},
      }
    default:
      return state
  }
}
